import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ErrorService } from '../../services/error.service';
import { FileAccessService } from '../../services/fileaccess.service';
import { File } from '../../model/files';
import FileSaver from 'file-saver';

@Component({
  selector: 'app-file-view',
  templateUrl: './file-view.component.html',
  styleUrls: ['./file-view.component.scss']
})
export class FileViewComponent implements OnInit {

  @Input()
  filesList: File[];

  @Input()
  viewedFileStructure:any;

  viewedFileStructureArray:{name:string, value:any, created? : number, folderPath?:string[]}[];

  constructor(private fileAccessService: FileAccessService, private errorService: ErrorService) { }

  ngOnInit(): void {
    this.toArray();
  }

  ngOnChanges(_: SimpleChanges) {
    this.toArray();
  }

  originalOrder(a: any, b: any){
    return 0;
  }

  /* transform viewedFileStruture Json object into an array */
  toArray() {
    this.viewedFileStructureArray = this.toArrayRec(this.viewedFileStructure, []);
    this.viewedFileStructureArray.sort((a,b)=> {
      if(b.value == null) {
        return -1;
      }
      if(a.value == null) {
        return 1;
      }
      return 0;
    })
  }

  /* recursive method to transform file structure nodes into arrays */
  toArrayRec(viewedFileStructure, folderPath: string[]) {
    const array = [];
    for(let item in viewedFileStructure) {
      if(JSON.stringify(viewedFileStructure[item]) != '{}') {
        array.push({
          name: item,
          value : this.toArrayRec(viewedFileStructure[item], folderPath.concat([item]))
        });
      }
      else {
        array.push({
          name: item,
          value : null,
          created : this.getFileCreationDate(this.getFilePath(folderPath, item)),
          folderPath: folderPath
        })
      }
    }
    return array
  }

  /* triggers download file */
  clickFile(path:[], name:string) {
    this.downloadFile(path, name);
  }

  /* download a file from gcp */
  downloadFile(currentPath: [], fileName: string): void { 
    let ff = this.filesList.filter(f => f.title = fileName)[0];
    
    if(ff){
      let newFile = this.getFilePath(currentPath, ff.title);
      this.fileAccessService.downloadFile(newFile)
        .subscribe(val => {
          var file = new Blob([val], {type: ff.contentType});
          if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            (window.navigator as any).msSaveOrOpenBlob(file);
          }else {
            FileSaver.saveAs(file, fileName.substring(fileName.lastIndexOf('/')+1));
          }
      }), 
      error => console.log('Error downloading the file'),
      () => console.info('File downloaded successfully');
    }else{
      this.errorService.handlerError("File failed to download, please try again or contact support");
    }
  }

  /* get the original file path in gcp */
  getFilePath(folderPath, filename) {
    if (folderPath.length > 0) {
      return folderPath.join("/") + "/" + filename;
    } else {
      // no leading forwardslash
      return filename;
    }
  }

  getFileCreationDate(filename:string) {
    let i = this.filesList.findIndex(file => file.title == filename);
    if(i>=0) return Math.round(this.filesList[i].created / 1000);
    else return null;
  }
}
